module.exports = "\n  .title {\n    color: grey;\n    font-size: 18px;\n  }\n  \n  button {\n    border: none;\n    outline: 0;\n    display: inline-block;\n    padding: 8px;\n    color: white;\n    background-color: #000;\n    text-align: center;\n    cursor: pointer;\n    width: 100%;\n    font-size: 18px;\n  }\n  \n  a {\n    text-decoration: none;\n    font-size: 22px;\n    color: black;\n  }\n  \n  button:hover, a:hover {\n    opacity: 0.7;\n  }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/profile.component.css
// module id = ./src/app/profile/profile.component.css
// module chunks = main